import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
const PopoverButton = ({ children, className, ...props }) => {
    return (_jsx("hot-button", { ...props, slot: "button", class: clsx('hot-button hot-button--sm hot-button--custom border-small', className), children: children }));
};
export default PopoverButton;
